'use client';

import { usePremium } from '@/contexts/PremiumContext';
import { useEffect } from 'react';

interface GoogleAdProps {
  slot: string;
  format?: 'auto' | 'fluid' | 'rectangle' | 'vertical' | 'horizontal';
  className?: string;
}

export function GoogleAd({ slot, format = 'auto', className = '' }: GoogleAdProps) {
  const { isPremium } = usePremium();

  useEffect(() => {
    if (isPremium) return;

    try {
      // @ts-ignore
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (error) {
      console.error('Google Ads error:', error);
    }
  }, [isPremium]);

  // Ne pas afficher si premium
  if (isPremium) {
    return null;
  }

  return (
    <div className={`google-ad-container ${className}`}>
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-XXXXXXXXXX" // À remplacer par votre ID
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
      <p className="text-xs text-center text-[#a8b2d1] mt-2">Publicité</p>
    </div>
  );
}

// Composant pour la bannière horizontale en haut
export function GoogleAdBanner() {
  return (
    <GoogleAd
      slot="1234567890"
      format="horizontal"
      className="my-4 max-w-7xl mx-auto"
    />
  );
}

// Composant pour la bannière verticale sidebar
export function GoogleAdSidebar() {
  return (
    <GoogleAd
      slot="0987654321"
      format="vertical"
      className="my-4"
    />
  );
}
